module.exports = __webpack_public_path__ + "img/optimizely.4b6b7326.jpg";